import React from 'react';
import { Dialog } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { OptionGroupDto } from '@/types';
import { OptionGroupWizard } from '../OptionGroupWizard/OptionGroupWizard';
import OptionGroupLabel from '../OptionGroupLabel/OptionGroupLabel';
import theme from './OptionGroupEditDialog.module.scss';

export interface OptionGroupEditDialogProps {
    optionGroup: OptionGroupDto;
    open: boolean;
    toggle(flag: boolean): void;
    onAccept?(): void;
}

export const OptionGroupEditDialog: React.FC<OptionGroupEditDialogProps> = ({ optionGroup, open, toggle, onAccept }) => {
    return (
        <Dialog onOpenChange={toggle} open={open}>
            <Dialog.Content showCloseButton contentWidth="lg" className={theme.container}>
                <Dialog.Header>
                    <Trans>Update option</Trans>{' '}
                    <OptionGroupLabel name={optionGroup.name} internalNote={optionGroup.internalNote} />
                </Dialog.Header>
                <OptionGroupWizard
                    isEditing
                    onCancel={() => toggle(false)}
                    onSubmit={() => toggle(false)}
                    sourceOptionGroupId={optionGroup.id}
                    projectId={optionGroup.projectId}
                />
            </Dialog.Content>
        </Dialog>
    );
};
